import {AbstractModel, DateConverter, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ProjectActivity} from "../../project-misc/data/project/activity/project-activity";
import {ProductionPlanningPost} from "./production-planning-post";
import {ProductionPlanningWeek} from './production-planning-week';

@JsonObject('model.ProductionPlanningEvent')
export class ProductionPlanningEvent extends AbstractModel {

  @JsonProperty(Number, 'duration')
  duration: number;

  @JsonProperty([ProjectActivity], 'activities')
  activities: ProjectActivity[];

  @JsonProperty(ProductionPlanningPost, 'post')
  post: ProductionPlanningPost;

  @JsonProperty(ProductionPlanningWeek, 'postWeek')
  postWeek: ProductionPlanningWeek;

  @JsonProperty(DateConverter, 'weekToReview')
  weekToReview?: Date;
}
